import { downloadApplicationFile } from '../services/ApplicationService';
import {
  downloadClientDocument,
  downloadLufeCloudFile,
} from '../services/ClientService';
import { getMimeType } from './Utils';
import { isLufeCloudFileName } from './isLufeCloudFileName';

export type DocumentBlobResult = {
  blob: Blob;
  filename: string;
};

type DownloadResponse = {
  success: boolean;
  data?: Blob | ArrayBuffer;
  status?: number;
};

const toBlob = (data: Blob | ArrayBuffer, mimeType: string): Blob =>
  data instanceof Blob ? data : new Blob([data], { type: mimeType });

export async function downloadApplicationDocumentToBlob(
  cuit: string,
  applicationId: string | undefined,
  filename: string
): Promise<DocumentBlobResult | null> {
  if (!filename) {
    return null;
  }

  try {
    if (isLufeCloudFileName(filename)) {
      const response = await downloadLufeCloudFile(cuit, filename);
      if (response?.success && response.data) {
        return {
          blob: toBlob(response.data, 'application/pdf'),
          filename: `${filename}.pdf`,
        };
      }
      return null;
    }

    let response: DownloadResponse = applicationId
      ? await downloadApplicationFile(cuit, applicationId, filename)
      : await downloadClientDocument(cuit, filename);

    if (
      !response.success &&
      response.status === 500 &&
      filename.includes('.')
    ) {
      response = await downloadLufeCloudFile(
        cuit,
        filename.replace(/\.[^/.]+$/, '')
      );
    }

    if (response?.success && response.data) {
      const mimeType = getMimeType(filename);
      return {
        blob: toBlob(response.data, mimeType),
        filename,
      };
    }

    return null;
  } catch (error) {
    console.error(`Error downloading file to blob (${filename}):`, error);
    return null;
  }
}
